import React from "react";
import { personalFile } from "../content/portfolio";
import portrait640 from "../media/profile_pic-640.webp";
import portrait960 from "../media/profile_pic-960.webp";
import portrait1280 from "../media/profile_pic-1280.webp";
import portrait1600 from "../media/profile_pic-1600.webp";

// object-fit: cover scales this square photo to the larger side of its container.
const portraitSizes = "(max-width: 700px) max(calc(100vw - 22px), min(520px, 67vh)), max(515px, calc(100vh - clamp(28px, 6vw, 68px)))";

export default function PersonalFile({dialogRef, onClose}) {
  return (
    <div className="portrait-modal-backdrop" role="presentation" onClick={event => { if (event.target === event.currentTarget) onClose(); }}>
      <div className="portrait-modal" role="dialog" aria-modal="true" aria-label="About me" ref={dialogRef} tabIndex={-1}>
        <button type="button" className="portrait-modal-close" onClick={onClose} aria-label="Close about me">Close <span aria-hidden="true">×</span></button>
        <div className="personal-file-layout">
          <div className="portrait-modal-image">
            <img src={portrait960}
              srcSet={`${portrait640} 640w, ${portrait960} 960w, ${portrait1280} 1280w, ${portrait1600} 1600w`}
              sizes={portraitSizes} width={1600} height={1600}
              fetchPriority="high" loading="eager" decoding="async"
              alt="Portrait of Nikolay Lebedinsky" />
            <span className="portrait-modal-glitch" aria-hidden="true" />
          </div>
          <section className="personal-file-copy" aria-labelledby="personal-file-title">
            <h2 id="personal-file-title">About me</h2>
            <div className="personal-file-section personal-file-experience">
              <h3 className="personal-file-section-label">Work experience</h3>
              {personalFile.experience.map(entry => (
                <article key={entry.company}>
                  <h4>{entry.company}</h4>
                  {entry.roles.map(role => (
                    <div className="personal-file-role" key={entry.company + role.title}>
                      <div><strong>{role.title}</strong><time>{role.period}</time></div>
                      <p>{role.summary}</p>
                    </div>
                  ))}
                </article>
              ))}
            </div>
            <div className="personal-file-section personal-file-education">
              <h3 className="personal-file-section-label">Education</h3>
              {personalFile.education.map(entry => (
                <article key={entry.institution + entry.period}>
                  <div><h4>{entry.institution}</h4><time>{entry.period}</time></div>
                  <strong>{entry.credential}</strong>
                </article>
              ))}
            </div>
            <div className="personal-file-section personal-file-credentials">
              <h3 className="personal-file-section-label">Credentials</h3>
              {personalFile.credentials.map(credential => (
                <article key={credential.title}>
                  <strong>{credential.title}</strong><small>{credential.issuer} · Issued {credential.issued}</small>
                </article>
              ))}
            </div>
            <div className="personal-file-section personal-file-signals">
              <h3 className="personal-file-section-label">Colleague signals</h3>
              <ul>{personalFile.colleagueSignals.map(signal => <li key={signal}>{signal}</li>)}</ul>
              <a className="personal-file-source" href="https://www.linkedin.com/in/nikolay-lebedinsky/" target="_blank" rel="noreferrer">Colleague recommendations on LinkedIn <span aria-hidden="true">↗</span></a>
            </div>
            <div className="personal-file-section personal-file-outside">
              <h3 className="personal-file-section-label">Outside work</h3>
              {personalFile.outsideWork.map(item => (
                <a key={item.href} href={item.href} target="_blank" rel="noreferrer" aria-label={item.label}>
                  <strong>{item.label}</strong><small>{item.detail}</small><span aria-hidden="true">↗</span>
                </a>
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
